"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationStatus = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["PENDING"] = "PENDING";
    InvitationStatus["SENT"] = "SENT";
    InvitationStatus["ACCEPTED"] = "ACCEPTED";
    InvitationStatus["DECLINED"] = "DECLINED";
    InvitationStatus["PENDING_REVOKE"] = "PENDING_REVOKE";
    InvitationStatus["REVOKED"] = "REVOKED";
    InvitationStatus["Pending"] = "PENDING";
    InvitationStatus["Sent"] = "SENT";
    InvitationStatus["Accepted"] = "ACCEPTED";
    InvitationStatus["Declined"] = "DECLINED";
    InvitationStatus["PendingRevoke"] = "PENDING_REVOKE";
    InvitationStatus["Revoked"] = "REVOKED";
})(InvitationStatus || (exports.InvitationStatus = InvitationStatus = {}));
